import { CalendarJobTitleDto, CalendarUserFilterRs } from '@domain/rs/calendar/CalendarUserFilterRs';
import { BusinessSizeType } from '@domain/constant/businessSize';
import { RecruitCategoryType } from '@domain/constant/recruitCategoryType';
import { LocationCode } from '@domain/constant/locationType';
import DateFormat from '@utils/date/format';
import DateUtil from '@utils/date/util';

export class CalendarFilterFormVO {
  keyword = '';
  jobTitles: CalendarJobTitleDto[] = [];
  recruitmentTypes: RecruitCategoryType[] = [];
  businessSizeTypes: BusinessSizeType[] = [];
  locations: string[] = [];
  targetMonth = DateFormat.format(DateUtil.getNow(), 'yyyy-MM');

  constructor(rs?: CalendarUserFilterRs) {
    if (rs?.jobTitles) this.jobTitles = rs.jobTitles;
    if (rs?.recruitmentTypes) this.recruitmentTypes = rs.recruitmentTypes;
    if (rs?.businessSizeTypes) this.businessSizeTypes = rs.businessSizeTypes;
    if (rs?.locations) this.locations = rs.locations.map((code) => LocationCode[code]);
  }
}
